import { jsx as _jsx } from "react/jsx-runtime";
var BirreteApps = function BirreteApps(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.878 2.965 20.99 6.73c.336.156.618.398.815.698a1.807 1.807 0 0 1-.001 2c-.2.3-.486.541-.826.694l-1.632.69v.11l-1.8.808v-.104l-4.68 2.114a2.03 2.03 0 0 1-1.728 0l-4.68-2.114v.114l-1.836-.825v-.103l-.924-.43v4.025c0 .225-.095.44-.264.6a.928.928 0 0 1-.636.248.928.928 0 0 1-.636-.248.824.824 0 0 1-.264-.6V8.663a1.62 1.62 0 0 1 0-.237 1.798 1.798 0 0 1 .304-1.002c.2-.3.485-.54.824-.694l8.1-3.765a2.055 2.055 0 0 1 .964-.194l.004-.002.003.003c.271.012.537.078.78.193Zm-8.256 9.047v6.579a.83.83 0 0 0 .3.576l.156.136c1.85 1.71 4.339 2.666 6.93 2.666 2.591 0 5.08-.957 6.93-2.666l.144-.136a.824.824 0 0 0 .264-.599v-6.55l-1.8.809v.216l-4.938 2.277a1.5 1.5 0 0 1-1.262-.002L6.458 13.04v-.205l-1.836-.824Zm8.22 4.292h.17l.414-.26-.4.184c-.06.028-.121.053-.183.076Z",
      fill: color
    })
  });
};
export default BirreteApps;